import React from 'react';

const PreviousIcon = ({ className = '' }) => (
  <svg
    width="8"
    height="13"
    viewBox="0 0 8 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={`inline-block ${className}`}
  >
    <path
      d="M6.79405 0L0 6.5L6.79405 13L8 11.8463L2.41189 6.5L8 1.15375L6.79405 0Z"
      fill="currentColor"
    />
  </svg>
);

export default PreviousIcon;
